module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hollandsnieuwe-04.cfa148f2.jpg";